/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';

type ImgProps = React.ClassAttributes<HTMLImageElement> &
  React.ImgHTMLAttributes<HTMLImageElement>;

const LazyImage: React.FC<ImgProps> = ({ src, onError, ...props }) => {
  const fallback = '/assets/img/placeholder.jpg';
  const finalSrc = typeof src === 'string' && src ? src : fallback;

  const [isLoaded, setIsLoaded] = useState(false);

  const reducedSize =
    finalSrc && typeof finalSrc === 'string'
      ? `${finalSrc.split('?')[0]}?tr=w-4,h-4`
      : fallback;

  useEffect(() => {
    setIsLoaded(false);

    if (typeof window === 'undefined') return;

    const img = new Image();

    const handleLoad = () => setIsLoaded(true);
    const handleError = () => {
      setIsLoaded(true);
    };

    img.addEventListener('load', handleLoad);
    img.addEventListener('error', handleError);
    img.src = finalSrc;

    return () => {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };
  }, [finalSrc]);

  return (
    <div className={!isLoaded ? 'position-relative' : ''}>
      {!isLoaded && <div className="lds-dual-ring" />}
      <img
        src={isLoaded ? finalSrc : reducedSize}
        loading="lazy"
        {...props}
        onError={(e) => {
          if (onError) onError(e);
        }}
      />
    </div>
  );
};

export default LazyImage;
